import { render, staticRenderFns } from "./BuildingSelectModal.vue?vue&type=template&id=689a51b6&scoped=true&"
import script from "./BuildingSelectModal.vue?vue&type=script&lang=ts&"
export * from "./BuildingSelectModal.vue?vue&type=script&lang=ts&"
import style0 from "./BuildingSelectModal.vue?vue&type=style&index=0&id=689a51b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689a51b6",
  null
  
)

export default component.exports